import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { getDetailOrder } from 'features/orders/detailOrderSlice';
import { fetchCustomerInfo } from 'features/user/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import DetailOrder from './DetailOrder';
import BankTransferConfirmation from '../DetailOrderComponent/BankTransferConfirmation';
import PreviewImage from 'components/Modals/PreviewImage';
import EditOrder from './EditOrder';

const DetailOrderWithDriverComponent = () => {
  const dispatch = useDispatch();

  const orderData = useSelector(getDetailOrder);

  const { transactionKey } = useParams();
  const [searchParams] = useSearchParams();
  const isUpdating = searchParams.get('update');

  const [showImage, setShowImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [isPaymentValid, setIsPaymentValid] = useState(false);
  const [showBankTransferConfirmation, setShowBankTransferConfirmation] = useState(false);

  const getFileName = (path = '') => (typeof path === 'string' ? path?.split('/')?.pop() : '-');

  const imagePreviewHandler = (image) => {
    setShowImage(true);
    setSelectedImage(image);
  };

  useEffect(() => {
    if (transactionKey) {
      dispatch(fetchCustomerInfo(searchParams.get('customerId')));
    }
  }, [transactionKey]);

  return (
    <>
      {showBankTransferConfirmation ? (
        <BankTransferConfirmation
          getFileName={getFileName}
          imagePreviewHandler={imagePreviewHandler}
          orderData={orderData}
          setShowBankTransferConfirmation={setShowBankTransferConfirmation}
          setIsPaymentValid={setIsPaymentValid}
          isPaymentValid={isPaymentValid}
        />
      ) : isUpdating ? (
        <EditOrder transactionKey={transactionKey} />
      ) : (
        <DetailOrder
          getFileName={getFileName}
          orderData={orderData}
          imagePreviewHandler={imagePreviewHandler}
          isUpdate={isUpdating}
          isPaymentValid={isPaymentValid}
          setShowBankTransferConfirmation={setShowBankTransferConfirmation}
          transactionKey={transactionKey}
        />
      )}
      {showImage &&
        ReactDOM.createPortal(
          <PreviewImage image={selectedImage} setShow={() => setShowImage(false)} />,
          document.getElementById('modal'),
        )}
    </>
  );
};

export default DetailOrderWithDriverComponent;
